<template>
  <!-- MODAL -->
  <TransitionRoot as="template" :show="open">
    <Dialog class="relative z-50" @close="closeDialog">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </TransitionChild>
       <button ref="completeButtonRef" @click="completeOrder"></button>
      <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel class="relative transform overflow-hidden rounded-lg bg-white px-8 pb-8 pt-6 text-left shadow-xl transition-all sm:my-8 sm:w-full lg:max-w-4xl sm:p-6">
              <span ref="focoFake" tabindex="0" class="sr-only">Foco</span>
              <!-- Conteiner de título e botão de fechar -->
              <div class="flex justify-between items-start">
                <h2 class="text-xl font-bold leading-9 tracking-tight text-gray-900">Edição de Dados</h2>
                <button @click="closeDialog" type="button" class="text-gray-400 hover:text-gray-600 -mt-4">
                  <span class="sr-only">Fechar</span>
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              <!-- Formulário principal com flex -->
              <div class="mt-4">
                <form class="flex flex-wrap gap-4" @submit="sendData" method="POST">
                  <div v-for="(input, index) in inputsList" :key="index" class="flex-1 min-w-[300px] sm:min-w-[300px] lg:w-1/2">
                    <label :for="input.name" class="block text-sm font-medium leading-6 text-gray-900">{{ input.label }}</label>
                    <input
                      v-model="data[input.name]"
                      :id="input.name"
                      :name="input.name"
                      :type="input.type"
                      :required="false"
                      class="mt-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      :placeholder="placeHolderValues[input.name]"
                      :value="data[input.name]"
                    />
                  </div>
                  <!-- Botão de confirmar -->
                  <div class="w-full">
                    <button type="submit" class="flex w-full justify-center rounded-md bg-customPurple px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-sienaBlue">Confirmar</button>
                  </div>
                </form>
              </div>
              <div class="mt-4">
                <div class="relative my-8">
                  <div class="absolute inset-0 flex items-center">
                    <div class="w-full border-t border-gray-300"></div>
                  </div>
                  <!-- Botão de novo plano -->
                  <div class="relative flex justify-center">
                    <span class="bg-white px-4 text-sm text-gray-500">Novo Plano</span>
                  </div>
                </div>
              </div>
              <!-- Formulário para adicionar plano (embaixo do formulário principal) -->
                <form @submit.prevent="emitirNovoPlano" class="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4 pt-6">
                    <div>
                      <label class="block text-sm font-medium text-gray-700">Nome</label>
                      <input v-model="novoPlano.nome" type="text" required class="mt-1 block w-full rounded-md border-gray-300 shadow-sm" />
                    </div>

                    <div>
                      <label class="block text-sm font-medium text-gray-700">Descrição</label>
                      <input v-model="novoPlano.descricao" type="text" required class="mt-1 block w-full rounded-md border-gray-300 shadow-sm" />
                    </div>

                    <div>
                      <label class="block text-sm font-medium text-gray-700">Valor</label>
                      <input v-model="novoPlano.valor" type="number" step="0.01" required class="mt-1 block w-full rounded-md border-gray-300 shadow-sm" />
                    </div>

                    <div>
                      <label class="block text-sm font-medium text-gray-700">Regra de Faturamento</label>
                      <input v-model="novoPlano.regra_de_faturamento" type="text" required class="mt-1 block w-full rounded-md border-gray-300 shadow-sm" />
                    </div>

                    <div>
                      <label class="block text-sm font-medium text-gray-700">Tipo de Plano</label>
                      <select v-model="novoPlano.tipo_plano" required class="mt-1 block w-full rounded-md border-gray-300 shadow-sm">
                        <option value="">Selecione</option>
                        <option value="Vida em Grupo">Vida em Grupo</option>
                        <option value="Vida Individual">Vida Individual</option>
                      </select>
                    </div>
                    
                  <!-- Botão de adicionar plano -->
                  <div class="col-span-2 flex justify-end">
                    <button type="submit" class="bg-customPurple text-white text-sm px-4 py-1.5 rounded-md hover:bg-sienaBlue">
                      Adicionar Plano
                    </button>
                  </div>
                </form>
              <!-- Area de Listagem simples de planos -->
              <div v-if="Array.isArray(placeHolderValues.planos) && placeHolderValues.planos.length > 0">
                <!-- Separador visual -->
                <div class="relative my-8">
                  <div class="absolute inset-0 flex items-center">
                    <div class="w-full border-t border-gray-300"></div>
                  </div>
                  <div class="relative flex justify-center">
                    <span class="bg-white px-4 text-sm text-gray-500">Planos Vinculados</span>
                  </div>
                </div>

                <!-- Lista -->
                <div class="w-full px-1 sm:px-0 lg:px-1">
                  <SimpleList
                    :headers="['NOME', 'VALOR', 'FATURAMENTO']"
                    :fields="['nome', 'valor', 'regra_de_faturamento']"
                    :data="placeHolderValues.planos"
                    :headerInfo="{ title: 'Planos vinculados', description: 'Lista de planos da empresa' }"
                    @delete-item="deletarPlano"
                  />
                </div>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>

import SimpleList from '@/components/generalcomponents/SimpleList.vue';
import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue';

  export default {
    name: 'EmpresasEditingForm',
    async created(){
    },
    props: {
      inputsList: {
        type: Array,
        required: true
      },
      open: {
        type: Boolean,
        required: true
      },
      placeHolderValues: {
        type: Object,
        required: true
      }
    },  
    data() {
      return {
        data:{},
        novoPlano: {
          nome: '',
          descricao: '',
          valor: null,
          regra_de_faturamento: ''
        },
        focoFake: null
      };
    },
    methods: {
      sendData(e) {
        e.preventDefault();
        this.$emit('editing-data', this.data,this.placeHolderValues.id);
      },
      closeDialog() {
        this.$emit('update-open', false);
      },
      deletarPlano(id){
        this.$emit('deletar-plano',id);
      },
      formatDate(dateString) {
        if (!dateString) return '';
        
        // Verifica se o valor contém data e hora, separa apenas a data (YYYY-MM-DD)
        if (typeof dateString === 'string' && dateString.includes(' ')) {
          return dateString.split(' ')[0]; // Retorna apenas a parte da data
        }
        
        return dateString; // Retorna o valor original se já estiver no formato correto
      },
      emitirNovoPlano() {
        if (!this.novoPlano.nome || !this.novoPlano.valor || !this.novoPlano.regra_de_faturamento) {
          alert('Preencha todos os campos do plano.');
          return;
        }

        const planoCompleto = {
          ...this.novoPlano,
          empresa_id: this.placeHolderValues.id
        };

        this.$emit('add-plano', planoCompleto);

        this.novoPlano = {
          nome: '',
          descricao: '',
          valor: null,
          regra_de_faturamento: ''
        };
      }
    },
    components:{
      Dialog,
      DialogPanel, 
      TransitionChild, 
      TransitionRoot,
      SimpleList
    },
  }
</script>